import Axios from "axios";
import { SERVER } from "../settings/connection";

export const axios = Axios.create({
    baseURL:SERVER,
    withCredentials:true
})